export default { 
  SET_ADMIN_TYPE_TRADE (state, val) {
    state.adminTypeTrade = val
  },
  SET_ADMIN_WALLET (state, val) {
    state.adminWallet = val
  }
}